enum EcommerceViewModeEnum {
    CARD = "CARD",
    LIST = "LIST",
}

export default EcommerceViewModeEnum;
